import { zodResolver } from "@hookform/resolvers/zod";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { z } from "zod";
import { HELP_AND_SUPPORT } from "../../../../services/ApiCalls";

const schema = z.object({
  name: z.string().trim().min(1, { message: "First name is required" }),
  email: z
    .string({
      required_error: "email is required",
    })
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
  msg: z.string().trim().min(1, { message: "message  is required" }),
});

const HelpSupport = () => {
  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
  });

  const submitHandler = async (data) => {
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }

    try {
      const res = await HELP_AND_SUPPORT({
        ...data,
        ...contactNumber,
      });

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        reset();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  return (
    <>
      <section className="helpSupport position-relative py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg="5" md="6" className="my-2">
              <div className="sectionHeader text-center mb-3">
                <h3 className="m-0 fw-sbold themeBlue">Help & Support</h3>
              </div>
              <Form onSubmit={handleSubmit(submitHandler)}>
                <Row className="justify-content-center">
                  <Col lg="12" className="my-2">
                    <input
                      type="text"
                      placeholder="Full Name"
                      className="form-control"
                      {...register("name")}
                    />
                    {
                      <p className="errorColor">
                        {errors?.name && errors.name?.message}
                      </p>
                    }
                  </Col>
                  <Col lg="12" className="my-2">
                    <input
                      type="email"
                      placeholder="Email Address"
                      className="form-control"
                      {...register("email")}
                    />
                    {
                      <p className="errorColor">
                        {errors?.email && errors.email?.message}
                      </p>
                    }
                  </Col>
                  <Col lg="12" className="my-2">
                    <PhoneInput
                      // country={"us"}
                      value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
                      onChange={(mobileNumber, { dialCode }) => {
                        setContactNUmber((p) => ({
                          countryCode: `+${dialCode}`,
                          mobileNumber: mobileNumber.replace(dialCode, ""),
                        }));
                      }}
                      country={'us'}
                    />

                    {
                      <p className="errorColor">
                        {Error?.contactNumber && Error?.contactNumber}
                      </p>
                    }
                  </Col>
                  <Col lg="12" className="my-2">
                    <textarea
                      name=""
                      id=""
                      rows="5"
                      placeholder="Message"
                      className="form-control"
                      {...register("msg")}
                    />
                    {
                      <p className="errorColor">
                        {errors?.msg && errors.msg?.message}
                      </p>
                    }
                  </Col>
                  <Col md="8" className="my-2">
                    <Button
                      className="d-flex align-items-center justify-content-center commonBtn w-100"
                      type="submit"
                    >
                      Send Message
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HelpSupport;
